import React from 'react';
import PropTypes from 'prop-types';
import Charac from '@/components/Charac';
import TextInfo, {
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_ALIGN,
} from '@gcloud-npm/next12.components.text-info-n';
import { CharacListCss } from './styles';

export const LAYOUT = {
  THREE_COLUMNS: 'THREE_COLUMNS',
  ALL_IN_LINE: 'ALL_IN_LINE',
};

const CharacList = ({
  title,
  listadoCaracteristicas,
  layout,
  iconProps,
  textInfoProps,
}) => {
  return (
    <>
      <section className="CharacList">
        <div className="container">
          {title && (
            <TextInfo
              className="CharacList__title"
              color={TEXT_INFO_COLOR.GREY_6}
              fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
              size={TEXT_INFO_SIZE.TITLE2}
              text={title}
              kind={TEXT_INFO_KIND.HEADING}
              level={TEXT_INFO_HEADING_LEVEL.H2}
              align={TEXT_INFO_ALIGN.CENTER}
            />
          )}
          <ul className={`CharacList__list CharacList__list--${layout}`}>
            {listadoCaracteristicas &&
              listadoCaracteristicas.map((carac) => (
                <li
                  key={`item-${carac.label}`}
                  className={`CharacList__item CharacList__item--${layout}`}
                >
                  <Charac
                    icon={carac.iconId}
                    label={carac.label}
                    description={carac.sublabel}
                    iconProps={iconProps}
                    textInfoProps={textInfoProps}
                  />
                </li>
              ))}
          </ul>
        </div>
      </section>
      <style jsx>{CharacListCss}</style>
    </>
  );
};

CharacList.propTypes = {
  title: PropTypes.string,
  listadoCaracteristicas: PropTypes.array,
  layout: PropTypes.oneOf(Object.values(LAYOUT)),
};

CharacList.defaultProps = {
  title: '',
  listadoCaracteristicas: [],
  layout: LAYOUT.THREE_COLUMNS,
};

export default CharacList;
